import Page from "../components/Page"
import errorImage from "../assets/images/Unauthorized-cat.png"

/**
 * Display this page if we receive a bad API response or other errors when loading a page.
 */
const UnauthorizedPage = () => {

    return (
        <Page>
            <h1>403: Unauthorized</h1>
            <img src={errorImage} alt="Image of cat stopping you from entering page" style={{width:200, height:200}}/>
            <p>You aren't allowed on this page, sorry!</p>
        </Page>
    );
};

export default UnauthorizedPage;